(() => {
  angular
    .module('gm.common.filters')
    .filter('gmDateRange', gmDateRangeFilter);

  function gmDateRangeFilter() {
    'ngInject';

    return (list, filter, field) => (list || []).filter((item) => {
      if ((filter.from > 0) && (item[field] < filter.from)) {
        return false;
      }

      if ((filter.to > 0) && (item[field] > filter.to)) {
        return false;
      }

      return true;
    });
  }
})();
